import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {login} from 'apa/actions';
import {Button, Card, CardBody, CardFooter, CardHeader, Container, FormGroup, Input, Label} from 'reactstrap'
import Loading from 'apa/components/Loading';
import autobind from 'autobind-decorator';
import { Redirect } from 'react-router-dom';
import { BaseUrl } from '../../BaseUrl/BaseUrl';
import secureLocalStorage from 'react-secure-storage';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import PdfLightbox from './PdfLightBox';

function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array
}

function chooseQuestions(questionList, number, lastAttempt, categoryId) {

    let workingQuestionList = [];
    let clearedQuestionList = [];

    if (lastAttempt != null) {
        // Cheack for each question of the catalogue, if it was part of the last attempt.
        // If it was not part of the last attempt, push it onto the base-list for the next attempt.
        for (let i = 0; i < questionList.length; i++) {
            if (lastAttempt.map((el) => el.text).indexOf(questionList[i].text) === -1){
                clearedQuestionList.push(questionList[i]);
            }

        }
    }

    const n = parseInt(number);

    // If not enough questions for the next attempt or if there was no last attempt,
    // use the complete question list
    if (n > clearedQuestionList.length) {
        workingQuestionList = questionList;
    } else {
        workingQuestionList = clearedQuestionList;
    }

    const max = Math.min(workingQuestionList.length, n)
    const questions = shuffleArray(workingQuestionList, max);
    const n_q = questions.slice(0, max);
    for(let i = 0; i < n_q.length; i++) {
        const answers = n_q[i].answers;
        if(answers)  {
            n_q[i].answers = shuffleArray(answers, 6).slice(0, 6)
            n_q[i].idx = categoryId + '_' + n_q[i].idx // To differentiate between questions of different categories. Workaround because the answer-array has not enough dimensions
        }
    }
    return n_q
}

@connect(
    state => {
        return {
            auth: state.apa
        }
    }
)
class T extends Component {

    state = {
        current: 0,
        questions: [],
        selected: {},
        isLoading: false,
        results: {},
        interviewStatus: null,
        message: "",
        contactdetails: ""
    }

    constructor(props) {
        secureLocalStorage.setItem('lastActvity', new Date())
        super(props);
        const status = props.auth.user.access_code.status
        const percentage = props.auth.user.access_code.results.percentage
        // Double check the status 2 and use the percentage, because the status is set to 4 when a new attempt is started
        if(status === 2 || (percentage >= 50 && percentage < 60)) {
            this.state.questions = props.questions.slice(0, 3)
        } else {
            this.state.questions = props.questions
        }
        props.questions.filter(
            val => this.state.selected[val.idx] = []
        )
    }

    componentDidMount() {
        window.onpopstate=(event)=>{
            if(event.type === "popstate"){
               window.location.reload()
            }
        }
        const status = this.props.auth.user.access_code.status
        if(status !== 4){
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Token ${this.props.auth.token}`
            };
            const body = JSON.stringify(
                {
                    'status': 4
                }
            )
            // console.log("Body", body)
            fetch(
                `${BaseUrl}/api/auth/user/status/`,
                {headers, method: 'PATCH', body}
            )
        }
	}

    @autobind
    onSubmit() {
        const headers = {
            'Authorization': `Token ${this.props.auth.token}`,
            'Content-Type': 'application/json'
        };
        const questions = [...this.state.questions]

        for(let i = 0; i < questions.length; i++) {
            const question = questions[i];
            const answers = question.answers;
            for(let j = 0; j < answers.length; j++) {
                const answer = answers[j]
                answer.selected = this.state.selected[question.idx].indexOf(answer.idx) > -1
            }
        }
        const f_results = []
        const ScheduleInterview = {
            status: this.state.interviewStatus,
            message: this.state.message,
            contactdetails: this.state.contactdetails
        }
        // Code to store the previous attempted questions
        // const access_code = this.props.auth.user.access_code
        // if(access_code.results.results) {
        //     f_results.push(...access_code.results.results)
        // }
        f_results.push(...questions)
        const body = JSON.stringify(
            {
                'results': f_results,
                'schedule_interview': ScheduleInterview
            }
        )
        // console.log("Body", body)
        fetch(
            `${BaseUrl}/api/auth/user/submit/`,
            {headers, method: 'POST', body}
        ).then(res => res.json())
            .then(
                (res) => {
                    this.setState({isLoading: false})
                    window.location.replace('/training/status');
                }
            )
    }
    setScheduleInterview(event) {
        if(event.target.value == "true"){
            this.setState({
                interviewStatus: true
            })
        }else{
            this.setState({
                interviewStatus: false,
                message: "",
                contactdetails: ""
            })
        }
    }
    messageHandler(event) {
        this.setState({
            message: event.target.value
        })
    }
    contactdetailsHandler(event) {
        this.setState({
            contactdetails: event.target.value
        })
    }

    render() {
        if(this.props.auth.user.access_code?.status === 2 && this.props.auth.user.access_code?.attempts === 0 || this.props.auth.user.access_code?.status === 1 && this.props.auth.user.access_code?.attempts === 0 || this.props.auth.user.access_code?.status === 3) {
            return <Redirect to={'/training/status'} />
        }
        if(this.state.isLoading) {
            return <Loading/>
        }

        const current = this.state.current;
        const questions = this.state.questions;
        const max = questions.length;
        const question = questions[current]
        const answers = question.answers || []
        const isSelected = (answer) => {
            if(this.state.selected[question.idx]) {
                const a = this.state.selected[question.idx].indexOf(answer.idx) > -1
                return a
            }
            return false
        }
        return (
            <>
            <Card style={{'width': '40em', 'margin': 'auto'}}>
                <CardHeader>
                    <strong>{question.text}</strong>
                </CardHeader>
                <CardBody>
                    {
                        answers.map((answer => (
                            <FormGroup key={`answer_${answer.idx}`} check>
                                <Label>
                                <Input type="checkbox"
                                       checked={isSelected(answer)}
                                       name={`answer_check_${answer.idx}`}
                                       onChange={
                                           e => {
                                               const selected = { ...this.state.selected };
                                                // Different behaviour depending on multiple- or single-choice question
                                               if (question.answers.length > 2) {
                                                   selected[question.idx].indexOf(answer.idx) === -1 ? selected[question.idx].push(answer.idx) : selected[question.idx].splice(selected[question.idx].indexOf(answer.idx), 1);
                                               } else {
                                                selected[question.idx] = [answer.idx]
                                               }

                                            this.setState({
                                                selected: selected
                                            });
                                           }
                                       }
                                />
                                {answer.text}
                                </Label>
                            </FormGroup>
                        )))
                    }
                   {
                  current == max - 1 &&
                  <div style={{backgroundColor: "#2d7691", padding: 6, borderRadius: 4}}>
                    <Label style={{color:'white'}}>
                        Sie wünschen ein persönliches Gespräch mit Ihrer Fachkraft für Arbeitssicherheit ? *
                    </Label>
                        <div onChange={this.setScheduleInterview.bind(this)}>
                            <FormGroup check>
                                <Label style={{color:'white'}} check>
                                    <Input type="radio" value={true} name="radio1" /> Ja
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label style={{color:'white'}} check>
                                    <Input type="radio" value={false} name="radio1" /> Nein
                                </Label>
                            </FormGroup>
                        </div>
                                    {this.state.interviewStatus == true &&
                    <>
                    <FormGroup>
                        <Label style={{color:'white'}} check>
                            Kontaktdaten (Telefon oder E-Mail): *
                        </Label>
                        <Input type="text" onChange={(e)=>this.contactdetailsHandler(e)} required={true}/>

                    </FormGroup>
                     <FormGroup>
                         <Label style={{color:'white'}} check>
                              Persönliche Nachricht:
                         </Label>
                         <Input type="textarea" onChange={(e)=>this.messageHandler(e)}/>
                     </FormGroup>
                     </>
                    }
                    </div>
                    }
                </CardBody>
                <CardFooter>
                    {
                        question && question.additional_information_link && (
                            <PdfLightbox
                                file={`${BaseUrl}${question.additional_information_link}`}
                            />
                        )
                    }
                    <p className={'text-center'}>
                        { current + 1} / { max }
                    </p>
                    <div>
                        {
                            current > 0 &&
                            <Button color='default' onClick={() => {this.setState({current: current - 1})}}>Zurück</Button>
                        }
                        {
                            current < max - 1 &&
                            <Button color={'primary'} style={{'float': 'right'}} onClick={() => {this.setState({current: current + 1})}}>Weiter</Button>
                        }
                        {
                            current == max - 1 &&
                            <Button disabled={this.state.interviewStatus == null || (this.state.interviewStatus == 1 && this.state.contactdetails.length < 6)} style={{'float': 'right'}} color='danger' onClick={this.onSubmit}>Abgabe</Button>
                        }
                    </div>
                </CardFooter>
            </Card>
            </>
        )
    }
}

@connect(
    state => ({
      apa: state.apa
    }),
    dispatch => ({
      login: (username, password) => (dispatch(login(username, password)))
    })
)
export default class Test extends Component {
    state = {
        timeoutReminder: false,
        timeIntervalID: 0,
    }
    constructor(props) {
        super(props);
    }
    render() {
        const isLoading = this.props.apa.isLoading;
        if(isLoading) {
            return <Loading/>
        }
        if(this.props.apa.user.is_superuser == false){
              if(this.state.timeoutReminder == false){
                document.addEventListener("mousemove", () =>{
                    secureLocalStorage.setItem('lastActvity', new Date())
                  });
                  document.addEventListener("click", () =>{
                    secureLocalStorage.setItem('lastActvity', new Date())
                  });
                let timeInterval = setInterval(() => {
                    let lastAcivity = secureLocalStorage.getItem('lastActvity')
                    var diffMs = Math.abs(new Date(lastAcivity) - new Date()); // milliseconds between now & last activity
                    var seconds = Math.floor((diffMs/1000));
                    var minute = Math.floor((seconds/60));
                    //console.log(seconds +' sec and '+minute+' min since last activity')
                    if(seconds == 240){
                        clearInterval(timeInterval)
                        this.setState({
                            timeoutReminder: true
                        })
                    }
                  },1000)
              }
        }
        const access_code = this.props.apa.user.access_code;
        if(access_code.attempts === 0 || access_code.status === 3) {
            return <Redirect to={'/training/status'} />
        }
        const customer_name = this.props.apa.user.access_code.training.customer_name;
        const training_name = this.props.apa.user.access_code.training.name;
        const training = this.props.apa.user.access_code.training;
        const last_attempt = this.props.apa.user.access_code.results.results;
        const data = training.data;
        const questions = [];
        for (let category of data) {
            questions.push(
                ...chooseQuestions(category.questionList, category.number, last_attempt, category.id)
            )

        }

        const renderTime = (time) => {
            return (
              <div>
                <div style={{display: "flex", placeContent: "center", fontSize: "16px",
                fontStyle: "italic",
                fontWeight: 600,
                fontVariant: "small-caps"}}
              >{time}</div>
                <div style={{display: "flex", placeContent: "center", fontSize: "16px",
                fontStyle: "italic",
                fontWeight: 600,
                fontVariant: "small-caps"}}>Sekunden</div>
              </div>
            );
          };
        return (
            <Container>
                <div style={{position: "relative",
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}>
                <h1>
                    { customer_name }
                </h1>
                <div style={{paddingTop: 10}}>
                    { this.state.timeoutReminder &&
                    <div style={{position: "relative",
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    }}>
                    <CountdownCircleTimer
                        isPlaying
                        duration={60}
                        colors={['#004777', '#F7B801', '#A30000', '#A30000']}
                        colorsTime={[45, 30, 15, 0]}
                        size={100}
                        trailStrokeWidth={6}
                        strokeWidth={6}
                        trailColor="#b8bbbc"
                        onComplete={()=>{
                            window.location.replace('/login')
                            // console.log('No activity from last 5 minutes... Logging Out')
                            secureLocalStorage.removeItem('lastActvity')
                            localStorage.removeItem('token')
                        }}
                    >
                        {({ remainingTime }) => renderTime(remainingTime)}
                    </CountdownCircleTimer>
                    <div style={{marginLeft: 10}}>
                        <button className="Stop-btn" onClick={() => {this.setState({timeoutReminder: false})}}>Stoppen</button>
                    </div>
                   </div>
                 }
                </div>
                </div>
                <h2>
                    { training_name }
                </h2>
                <T questions={questions} />
            </Container>
        )
    }
}

Test.propTypes = {
    login: PropTypes.func,
    isAuthenticated: PropTypes.bool,
    errors: PropTypes.object
}
